/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetPartnerSettings200ResponseDataInner
 */
export interface GetPartnerSettings200ResponseDataInner {
  /**
   * Группа настройки
   * @type {string}
   * @memberof GetPartnerSettings200ResponseDataInner
   */
  group: string
  /**
   * Ключ настройки
   * @type {string}
   * @memberof GetPartnerSettings200ResponseDataInner
   */
  key: string
  /**
   *
   * @type {any}
   * @memberof GetPartnerSettings200ResponseDataInner
   */
  value?: any | null
}

/**
 * Check if a given object implements the GetPartnerSettings200ResponseDataInner interface.
 */
export function instanceOfGetPartnerSettings200ResponseDataInner(
  value: object
): value is GetPartnerSettings200ResponseDataInner {
  if (!('group' in value) || value['group'] === undefined) return false
  if (!('key' in value) || value['key'] === undefined) return false
  return true
}

export function GetPartnerSettings200ResponseDataInnerFromJSON(
  json: any
): GetPartnerSettings200ResponseDataInner {
  return GetPartnerSettings200ResponseDataInnerFromJSONTyped(json, false)
}

export function GetPartnerSettings200ResponseDataInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPartnerSettings200ResponseDataInner {
  if (json == null) {
    return json
  }
  return {
    group: json['group'],
    key: json['key'],
    value: json['value'] == null ? undefined : json['value'],
  }
}

export function GetPartnerSettings200ResponseDataInnerToJSON(
  value?: GetPartnerSettings200ResponseDataInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    group: value['group'],
    key: value['key'],
    value: value['value'],
  }
}
